// extracted by mini-css-extract-plugin
export default {"scim":"SCIMTokens_scim__wK5Yq","visibilityButton":"SCIMTokens_visibilityButton__ESXBw"};